import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { NavigateService } from '../../service/navigate.service';
import { PersonService } from '../../service/person.service';
import { EventsService } from '../../service/events.service';
import { UserInfoModel } from '../../model/user.model';

declare var $:any;

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})

export class DetailComponent implements OnInit{
    id: number;             // id
    detailInfo: any = {};   // 详情
    loginModal: any = {     // 登录弹窗
        isSigninShow: false,
        title: 'CHINAICAC MEMBER SIGN IN',
    };
    applyModal: any = {     // 报名弹窗
        isRegisterShow: false,
        title: 'Please complete your registration information',
        fName: '',
        lName: '',
        email: '',
        school: '',
        id: '',
    };

    constructor(
        private route: ActivatedRoute,
        private domSanitizer: DomSanitizer,
        private navigateService: NavigateService,
        private personService: PersonService,
        private eventService: EventsService
    ){
        this.id = +this.route.snapshot.paramMap.get('id');
    }

    ngOnInit(){
        this.getDetailInfo();
        setTimeout(function(){
            $('.wrap-box').css("min-height", $(window).height());
        }, 0);
    }

    // 获取详情
    getDetailInfo(){
        this.eventService.getConferenceDetail(this.id).subscribe(res => {
            if (res.status === 200){
                this.detailInfo = res.data;
                const now = Date.now();
                // 是否在报名时间内
                this.detailInfo['inApplyTime'] = now >= this.detailInfo.signBeginTime && now <= this.detailInfo.signOverTime;
                // 可下载的资料
                this.detailInfo['files'] = eval(this.detailInfo.files);
                // 活动介绍安全转化
                this.detailInfo.intro = this.domSanitizer.bypassSecurityTrustHtml(
                    this.detailInfo.intro.replace(/<img/g, '<img style="display: block; max-width: 100%; margin: 20px auto 0;"')
                );
            }else if (res.status === 201){
                this.loginModal.isSigninShow = true;
            }
        });
    }

    // 资料下载
    download(url: string){
        window.open(url);
    }

    // 会议报名
    register(){
        // 判断是否登录
        this.personService.getUserInfo().subscribe(res => {
            if (res.ok){
                const userInfo = new UserInfoModel(res.data);
                this.applyModal = {
                    ...this.applyModal,
                    isRegisterShow: true,
                    fName: userInfo.firstName,
                    lName: userInfo.lastName,
                    email: userInfo.email,
                    school: userInfo.school,
                    id: this.id,
                };
            }else{
                this.loginModal.isSigninShow = true;
            }
        });
    }
    registerEmit(msg: number){
        if (msg === 1) this.detailInfo.userHasSign = true;
    }

    // 登录弹窗关闭
    loginModalCancel(){
        this.loginModal.isSigninShow = false;
        this.navigateService.popRoute();
    }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/events/detail/detail.component.ts